module.exports = __webpack_public_path__ + "assets/img/book.0a23280e.svg";